import {apiStore} from './api';

/**
 * Список валют
 */
export const currencies = apiStore<CurrencyItem[]>([], '/api/currency', {
    auto_update_timeout: 60000,
});
